import { useSession } from "next-auth/react"

import styles from './styles.module.scss';
import { PulseLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useRef, useState } from "react";
import errorMsg from "../../../../Functions/errorMsg";
import successMsg from '../../../../Functions/successMsg';
import axios from "axios";
import { useSocket } from "../../../../Context/socket";

export default function QuickMessage({ handleHasNewConvo, profileUsername, closeMessageBox }) {

    const toUser = profileUsername;

    const { socket, socketConnected, onlineUsers } = useSocket();
    const { data: session, status } = useSession();

    const messageRef = useRef(null);
    const [pendingSend, setPendingSend] = useState(false);

    function loadingState() {
        if(!socket) return 'loading';
        if(!socketConnected) return 'loading';
        if(pendingSend === true) return 'loading';
        if(status === 'loading') return 'loading';
        if(status === 'unauthenticated') return false;
        if(status === 'authenticated') return true;
        return false;
    }

    async function handleSendMessage(e) {
        e.preventDefault();
        if(status === 'loading') return;
        if(!session) return errorMsg("Please login to message this user.");
        if(status === 'unauthenticated') return errorMsg("Please login to message this user.");
        if(pendingSend === true) return;
        if(!messageRef || !messageRef.current) return;
        const messageText = messageRef.current.value;
        if(messageText.length === 0) return errorMsg("Please enter your message before sending.");
        if(messageText.length > 500) return errorMsg("Message cannot be over 500 characters.")
        
        const senderID = session.user.token.id;
        const sender = session.user.token.username;

        const basicConvoData = {
            type: 'General',
            receiver: toUser,
            sender: sender,
            creationDate: new Date().toISOString()
        }

        setPendingSend(true);

        const result = await axios.post(`${window.location.origin}/api/messaging/create`, {
            conversationData: basicConvoData,
            messageText: messageText,
            senderID: senderID
        }).catch((error) => {
            errorMsg(error?.response?.data?.status || error.toString())
        });

        if(result && result.status === 200) {
            const newConvoData = result.data;

            const hasNewConvoData = {
                hasConvo: true,
                convoID: newConvoData._id
            }

            handleHasNewConvo(hasNewConvoData)

            socket.emit('createNewConversation', newConvoData)

            successMsg("Your message was sent.");
            closeMessageBox();
        }

        setPendingSend(false);
    }

  return (
    <section id={styles.container}>
        <FontAwesomeIcon onClick={closeMessageBox} icon={faXmark} id={styles.exit} />
        { loadingState() === 'loading' && <div><PulseLoader color='#FFFFFF' /></div> }
        { loadingState() === false && <div><h1>Please login to message this user</h1></div> }
        { loadingState() === true && <div>
            <textarea ref={messageRef} placeholder={`Send a message to ${toUser}.`} maxLength={500} />
            <FontAwesomeIcon onClick={handleSendMessage} icon={faPaperPlane} id={styles.icon} />
        </div> }
    </section>
  )
}